// *********************************
// CoolGames Builder JavaScript file
import { tbEase } from "../engine/tbEase";
import { tbVectorFont } from "../engine/tbVectorFont";
import { PhysicsSettings } from "../settings/PhysicsSettings";
import { ScoreSettings } from "../settings/Settings";
import { angrybirds_regular } from "./AssetDefinitions/FontDefinitions";
import { ObjectPool } from "./ObjectPool";
import { getContainerForLayer, Layer } from "./SceneController";
import { playController } from "./gameController";
// *********************************
export var floater = floater || {};
floater.initFloaterPool = function () {
    if (!floater.poolBlocks) {
        floater.poolBlocks = new ObjectPool(40, function () {
            return new floater.FloaterObj(0, ScoreSettings.floaterTextOptions, (1 / PhysicsSettings.textureResolution) * ScoreSettings.floaterScale, ScoreSettings.floaterMoveDist, ScoreSettings.floaterDuration);
        });
        floater.poolText = new ObjectPool(5, function () {
            return new floater.FloaterObj(0, ScoreSettings.floaterTextOptionsText, (1 / PhysicsSettings.textureResolution) * ScoreSettings.floaterScale, ScoreSettings.floaterMoveDistText, ScoreSettings.floaterDurationText);
        });
    }
};
floater.addFloater = function (points, x, y) {
    var f = floater.poolBlocks.get();
    f.add(points.toString(), x, y);
};
floater.addTextFloater = function (text, x, y, fontOverride) {
    var font = JSON.parse(JSON.stringify(ScoreSettings.floaterTextOptionsText));
    if (fontOverride) {
        for (var key in fontOverride) {
            font[key] = fontOverride[key];
        }
    }
    var f = floater.poolText.get();
    f.setFont(font, (1 / PhysicsSettings.textureResolution) * ScoreSettings.floaterScale);
    f.add(text.toString(), x, y);
};
floater.cleanFloaters = function () {
    floater.poolBlocks.clean();
    floater.poolText.clean();
};
floater.FloaterObj = function (delay, font, scaleFactor, moveDist, moveTime) {
    "use strict";
    if (delay === void 0) {
        delay = 0;
    }
    if (font === void 0) {
        font = angrybirds_regular;
    }
    this.setFont(font, scaleFactor);
    this.timer = 0;
    this.duration = moveTime;
    this.distance = moveDist;
    this.easeY = tbEase.easeCreateCombined([tbEase.easeConstant, tbEase.easeConstant, tbEase.easeInCubic], [false, false, false], [0.2, 0.0, 1.3]);
    this.easeAlpha = tbEase.easeCreateCombined([tbEase.easeConstant, tbEase.easeConstant, tbEase.easeInOutCubic], [false, false, false], [0.2, 0.4, 0.9]);
    this.easeScale = tbEase.easeCreateCombined([tbEase.easeOutOvershoot, tbEase.easeConstant, tbEase.easeConstant], [false, false, false], [0.2, 0.4, 0.9]);
    this.delay = delay;
    this.scale = 0;
    this.alpha = 1;
    this.active = false;
    this.onRemoveCallback = null;
};
floater.FloaterObj.prototype.setFont = function (font, scaleFactor) {
    if (font instanceof tbVectorFont) {
        font = font.clone();
    }
    else {
        var fnt = new tbVectorFont();
        fnt.setProperties(font);
        font = fnt;
    }
    this.workingFont = font;
    if (scaleFactor !== void 0) {
        this.workingFont.setScale(scaleFactor, scaleFactor);
    }
    this.workingFont.setBaseline("middle");
    this.workingFont.setAlign("center");
    this.scaleFactor = scaleFactor;
};
floater.FloaterObj.prototype.update = function (timePassed) {
    "use strict";
    this.timer += timePassed;
    if (this.timer >= 0) {
        if (this.timer >= this.duration) {
            this.remove();
        }
        else {
            this.y = this.easeY(this.timer, this.from_y, this.to_y - this.from_y, this.duration);
            this.alpha = this.easeAlpha(this.timer, 1, -1, this.duration);
            this.scale = this.easeScale(this.timer, 0, this.scaleFactor, this.duration);
            this.workingFont.setPosition(this.x, this.y);
            this.workingFont.setAlpha(this.alpha);
            this.workingFont.setScale(this.scale * (playController.isMirrored ? -1 : 1), this.scale);
        }
    }
};
floater.FloaterObj.prototype.add = function (text, x, y) {
    "use strict";
    this.x = x;
    this.y = y;
    this.from_y = y;
    this.to_y = y - this.distance;
    this.timer = -this.delay;
    this.workingFont.setText(text);
    getContainerForLayer(Layer.floater).addChild(this.workingFont);
    this.update(0);
    this.active = true;
};
floater.FloaterObj.prototype.remove = function () {
    "use strict";
    getContainerForLayer(Layer.floater).removeChild(this.workingFont);
    this.active = false;
    if (this.onRemoveCallback) {
        this.onRemoveCallback();
    }
};
